import React from "react";
import QuoteInfo from "components/QuoteInfo.js";
import {getRequests, postRequest} from "../helpers/ApiHelper";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";

 class BookingConfirm extends React.Component {
     quote={};
     fleet={};
     extra={};
     startAddressType='';
    quoteLoading = true;
    quoteFleetLoading = true;
     state = {
     };
    constructor(props) {
        super(props);
        this.confirmClicked = this.confirmClicked.bind(this);
    }


    componentDidMount() {
        const quoteId =   localStorage.getItem('quoteId');
        const quoteFleetId =   localStorage.getItem('quoteFleetId');
        let quoteExtra =   localStorage.getItem('quoteExtra');
        const startAddressType =   localStorage.getItem('airportLocation');
         quoteExtra =   JSON.parse(quoteExtra);
        if(quoteId !== undefined && quoteFleetId !== undefined){
            getRequests('quote/'+quoteId).then(data => {
                getRequests('quote-fleet/'+quoteFleetId).then(fleetData => {
                    this.startAddressType = startAddressType;
                    this.quoteLoading = false;
                    this.quoteFleetLoading = false;
                    this.quote = data;
                    this.fleet = fleetData;
                    this.extra = quoteExtra;
                    console.log(this.extra);
                    this.setState(this.state);
                });
            });

        }
    }
    confirmClicked(){
        this.props.history.push("/book-payment");
    }

    render() {

        return (
            <section className="booking-flow-wrapper section-gap  ">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="booking-sidebar-wrapper">
                                <h4>Booking Information</h4>
                                {this.quoteLoading &&

                                <div className="loader-wrapper">
                                    <div className="  loader">
                                        <span>L</span>
                                        <span>o</span>
                                        <span>a</span>
                                        <span>d</span>
                                        <span>i</span>
                                        <span>n</span>
                                        <span>g</span>
                                    </div>
                                </div>

                                }
                                {!this.quoteLoading &&

                                    <QuoteInfo quoteData={this.quote} fleetData={this.fleet}/>

                                }

                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="booking-form-wrapper booking-confirm-page">
                                <form>
                                    <h4>Personal Information</h4>
                                    <div className="row no-gutter">
                                        <div className="col-md-4">
                                            <label htmlFor="name">Full Name</label>
                                            <p>{this.extra.passenger_name}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="email">Email Address</label>
                                            <p>{this.extra.passenger_email}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="phone">Phone Number</label>
                                            <p>{this.extra.passenger_mobile}</p>
                                        </div>
                                    </div>
                                    <h4>Travel Details</h4>
                                    <div className="row no-gutter">
                                        <div className="col-md-3">
                                            <label htmlFor="pax">No. of Passenger</label>
                                            <p>{this.extra.passenger_count}</p>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="pax">No. of Luggage</label>
                                            <p>{this.extra.luggage_count}</p>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Toddler Seat</label>
                                            <p>{this.extra.child_seat_count >= 0 ? this.extra.child_seat_count : 0}</p>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Infant Seat</label>
                                            <p>{this.extra.infant_seat_count >= 0 ? this.extra.infant_seat_count : 0}</p>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="pax">Booster Seat</label>
                                            <p>{this.extra.booster_seat_count >= 0 ? this.extra.booster_seat_count : 0}</p>
                                        </div>
                                        {/* <div className="col-md-3">
                                            <label htmlFor="pax">Waiting Time</label>
                                            <p>{this.extra.waiting_time} Minutes</p>
                                        </div> */}
                                        <div className="col-md-6 pt-4">
                                            <label htmlFor="pick-address ">PickUp address line</label>
                                            <p>{this.extra.pickup_address_line}</p>
                                        </div>
                                        <div className="col-md-6 pt-4">
                                            <label htmlFor="drop-address  ">Dropoff address line</label>
                                            <p>{this.extra.dropoff_address_line}</p>
                                        </div>
                                    </div>
                                    {(this.startAddressType === 'airport' || ( this.startAddressType !== 'airport' && this.quote.trip_type === 'round_trip' )) &&
                                    <h4>Flight Information</h4>}
                                    {(this.startAddressType === 'airport' || ( this.startAddressType !== 'airport' && this.quote.trip_type === 'round_trip' )) &&
                                    <div className="row no-gutter">
                                            <div className="col-md-6">
                                                <label htmlFor="airlinename">Airline Name</label>
                                                <p>{this.extra.airline_name}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="flighnum">Flight Number</label>
                                                <p>{this.extra.flight_number}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="arivaltime">Flight Arrival Time</label>
                                                <p>{this.extra.arrival_time}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="messgaeboard">
                                                    Name or Message on the pickup sign
                                                </label>
                                                <p>{this.extra.message_board}</p>
                                            </div>
                                    </div>

                                    }
                                    {this.quote.trip_type === 'round_trip' &&
                                        <h4>Return Journey Information</h4>
                                    }
                                    {this.quote.trip_type === 'round_trip' &&
                                    <div className="row no-gutter">
                                            <div className="col-md-6">
                                                <label htmlFor="messgaeboard">
                                                    Return Pickup Date
                                                </label>
                                                <p>{this.quote.return_pickup_date}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="messgaeboard">
                                                    Return Pickup Time
                                                </label>
                                                <p>{this.quote.return_pickup_time}</p>
                                            </div>
                                    </div>
                                    }
                                    {(this.startAddressType !== 'airport' || (this.startAddressType === 'airport' && this.quote.trip_type === 'round_trip')) &&
                                    <h4>Departure Flight Information</h4>
                                    }
                                    {(this.startAddressType !== 'airport' || ( this.startAddressType === 'airport' && this.quote.trip_type === 'round_trip' )) &&
                                    <div className="row no-gutter">

                                            <div className="col-md-6">
                                                <label htmlFor="messgaeboard">
                                                    Airline Name
                                                </label>
                                                <p>{this.extra.return_airline_name}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="messgaeboard">
                                                    Flight Number
                                                </label>
                                                <p>{this.extra.return_flight_number}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="messgaeboard">
                                                    Flight Departure Time
                                                </label>
                                                <p>{this.extra.return_arrival_time}</p>
                                            </div>
                                    </div>


                                    }

                                    <h4>Others Information</h4>
                                    <div className="row no-gutter">
                                        <div className="col-md-12 custom-radio">
                                            <label>Payment Method</label>
                                            <br/>
                                            <input
                                                type="radio"
                                                id="card"
                                                name="radio-group"
                                                checked
                                            />
                                            <label htmlFor="card">{this.extra.payment_type === 'card' ? 'Card' : 'Paypal'}</label>
                                        </div>

                                        <div className="col-md-12">
                                            <label htmlFor="messgae">Special Instructions</label>
                                            <p>
                                                {this.extra.special_instruction}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="form-check custom-check">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="terms"
                                            checked disabled
                                        />
                                        <label className="form-check-label" htmlFor="terms">
                                            I accept the
                                            <a href="/terms-and-condition" target="_blank">
                                                Terms & Conditions.
                                            </a>
                                        </label>
                                    </div>
                                    <button type="button" className="btn mt-4  pl-5 pr-5 pt-3 pb-3 btn-yellow" onClick={this.confirmClicked}>
                                        Confirm
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );

    }
}
export default withRouter(BookingConfirm);
